module.exports = __webpack_public_path__ + "media/images/site/arrow-down-25b77d8a35c71b2e4294e47a9aec5c04.svg";